import { useSyncExternalStore } from 'react';

/**
 * CSS 미디어 쿼리를 React 상태로 읽는다.
 *
 * 레이아웃을 CSS 로 해결할 수 있으면 CSS 로 해라 — 이 훅은 **DOM 구조 자체가
 * 달라져야 할 때만** 쓴다(예: 달력을 2개월 렌더할지 1개월 렌더할지).
 *
 * `useSyncExternalStore` 를 쓰는 이유는 SSR 안전성이다. 서버에서는 항상
 * `false`(= 데스크탑 가정)를 주고, 하이드레이션 직후 실제 값으로 맞춘다.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      // Safari 13 이하는 addEventListener 가 없다.
      if (mql.addEventListener) {
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
      }
      mql.addListener(onChange);
      return () => mql.removeListener(onChange);
    },
    () => {
      if (typeof window === 'undefined' || !window.matchMedia) return false;
      return window.matchMedia(query).matches;
    },
    () => false
  );
}

/** Tailwind `sm`(640px) 미만 — 즉 폰 세로 화면. */
export function useIsNarrow(): boolean {
  return useMediaQuery('(max-width: 639px)');
}
